import { render, staticRenderFns } from "./transition-setting.vue?vue&type=template&id=244013a8"
import script from "./transition-setting.vue?vue&type=script&lang=js"
export * from "./transition-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports